import React from 'react'
import styled from 'styled-components'

import { ColoredIcon } from '../../../../../src/ui/icons/Icon.jsx'

const ApiError = styled.li`
  padding: 18px 12px 20px;
  position: relative;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  height: ${({ isDesktop }) => isDesktop ? 'auto' : '100vh'};
`

const IconWrapper = styled.div`
  vertical-align: middle;
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`

const Labels = styled.div`
  margin-left: 12px;

  span {
    display: block;
  }

  .label {
    display: block;
    color: #333;
    ${({ theme }) => theme.fontSize('16px')};
    font-weight: 500;
    line-height: 150%;
  }

  .info {
    color: #666;
    ${({ theme }) => theme.fontSize('14px')};
    font-weight: 400;
    line-height: 18px;
  }
`

const ApiErrorWidget = ({ isDesktop, T }) => <ApiError
  data-cy='APIErrorWidget'
  isDesktop={isDesktop}
  tabIndex={'0'}>
  <ContentWrapper aria-label={T('flightDetails:Flight status service error')}>
    <IconWrapper aria-hidden={true}>
      <ColoredIcon id='triangle-warning' fillColor='#666666' width={40} height={40} />
    </IconWrapper>
    <Labels>
      <span className="label" data-cy='APIErrorLabel'>{T('flightDetails:Flight status service error')}</span>
      <span className="info" data-cy='APIErrorContent'>{T('flightDetails:We are sorry for the inconvenience and are working to fix the issue')}</span>
    </Labels>
  </ContentWrapper>
</ApiError>

export default ApiErrorWidget
